@if (eventStoreService.isKioskAllowed()) {
  <app-shoutout-create [kioskMode]="true"></app-shoutout-create>
} @else {
  <mat-card
    class="kiosk-banner"
    appearance="outlined"
    role="alert"
    aria-live="polite"
  >
    <mat-card-content class="kiosk-banner__content">
      <mat-icon class="kiosk-banner__icon" aria-hidden="true">warning</mat-icon>

      <div class="kiosk-banner__text">
        <div class="kiosk-banner__title">Kiosk POS is not allowed</div>
        <div class="kiosk-banner__subtitle">
          Please contact the event organizer to review your kiosk settings.
        </div>
      </div>
    </mat-card-content>
  </mat-card>
}
